import React, { Suspense } from "react"
import Container from "@material-ui/core/Container"
import CssBaseline from "@material-ui/core/CssBaseline"

import useStyles from "./styles/publicCss"
import Loading from "../components/Loading"

const PublicLayout = props => {
  const classes = useStyles(props)
  const { route, Component } = props

  const ContainerComponent = (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Suspense fallback={<Loading />}>
          <Component route={route} classes={classes} />
        </Suspense>
      </div>
    </Container>
  )

  return ContainerComponent
}

export default PublicLayout
